<template>
    <div class="" :class="{hide: !isShow}">
        <div class="van-overlay" style="z-index: 2001;" @click="handleCancel"></div>
        <van-picker class="main-con" ref="vpicker" show-toolbar title="标题" :columns="columns" @cancel="handleCancel"
            @confirm="selectArea" />
    </div>

</template>

<script>
    import { sendRequest } from '@/assets/public'
    export default {
        name: "newPicker",
        props: {
            isShow: {
                type: Boolean,
                default: true
            },
            cityList: {
                type: Array
            }
        },
        created() {
            this.columns = this.cityList
        },
        data() {
            return {
                columns: []
            };
        },
        methods: {
            handleCancel() {
                this.$emit('emitCancel', {});
            },
            selectArea(e) {
                let tindex = this.$refs.vpicker.getIndexes();
                let province_1 = this.columns[tindex[0]].value;
                let province_2 = this.columns[tindex[0]].children[tindex[1]].value;
                let province_3 = this.columns[tindex[0]].children[tindex[1]].children[tindex[2]].value;
                let obj = {
                    bool: true,
                    val: e,
                    provinceId: [province_1, province_2, province_3]
                }
                this.$emit('emitConfirm', obj);
            },

        }
    };
</script>

<style scoped>
    .van-overlay {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1 !important;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .7);
    }

    .main-con {
        position: fixed;
        left: 0;
        bottom: 0;
        z-index: 2;
        width: 100%;
    }
</style>